import { Outlet, useLocation } from "react-router-dom";
import Welcome from "../Welcome/Welcome";

function PublicLanding() {
    const location = useLocation();

    return location.pathname === '/' ? <Welcome /> : <Outlet />
}

export default PublicLanding;